import { GECKO_CONSTS, GECKO_UTILS } from '../../';
import { EventEmitter } from 'fbemitter';

class GeckoToastService {
  static emitter;
  get emitter() {
    return GeckoToastService.emitter;
  }
  set emitter(value) {
    GeckoToastService.emitter = value;
  }

  static items = [];
  get items() {
    return GeckoToastService.items;
  }
  set items(value) {
    GeckoToastService.items = value;
  }

  constructor() {
    // Create toast event emitter (if not already created)
    if (!this.emitter) this.emitter = new EventEmitter();
  }

  add(toast) {
    // https://ux.stackexchange.com/questions/11203/how-long-should-a-temporary-notification-toast-appear
    let timeOutLim = 3000;
    if (toast.message.length * 50 > 3000) {
      timeOutLim = toast.message.length * 50;
      if (timeOutLim > 7000) {
        timeOutLim = 7000;
      }
    }
    // Add toast
    this.items.push(toast);
    // Remove toast (after timeout)
    toast.timeout = setTimeout(() => {
      this.remove(toast);
    }, timeOutLim);

    this.emitter.emit('update');
  }

  remove(toastToRemove) {
    // Clear timeout
    if (toastToRemove.timeout) clearTimeout(toastToRemove.timeout);
    // Remove toast from toasts array
    this.items = this.items.filter((toast) => {
      return toast !== toastToRemove;
    });

    this.emitter.emit('update');
  }

  success(message) {
    this.add({
      message: message,
      type: GECKO_CONSTS.TOAST_TYPE_SUCCESS,
    });
  }

  warning(message) {
    this.add({
      message: message,
      type: GECKO_CONSTS.TOAST_TYPE_WARNING,
    });
  }

  error(message) {
    this.add({
      message: GECKO_UTILS.renderError(message),
      type: GECKO_CONSTS.TOAST_TYPE_ERROR,
    });
  }
}

export default GeckoToastService;
